import Component from "../../lib/component";
import {getDebouncedFunction} from "../../helpers/debounce";
import ComponentEvent from "../../lib/component_event";

export const SelecterFilterConfig = {
    componentTypeKey: 'SelecterFilter',
    baseHtmlClass: 'selector__filter',
    selector: '.selector__filter',

    itemContentSelector: '.selector__item__content',

    changedQueryEventName: 'Rankers.SelecterFilter:QueryChanged',
};

export class SelecterFilter extends Component {

    static createElement() {
        let element = document.createElement('div');
        element.classList.add(SelecterFilterConfig.baseHtmlClass);
        return element;
    }

    static createInputElement(parentElement) {
        let element = document.createElement('input');
        element.type = "search";
        element.placeholder = "Filter this list";
        return element;
    }

    constructor(id_or_element, selecter) {
        super({
            element: id_or_element,
            config: SelecterFilterConfig
        });

        this.selecter = selecter;

        this.inputElement = SelecterFilter.createInputElement(this.element);
        this.element.insertBefore(this.inputElement, this.element.firstChild);

        const debouncedHandler = getDebouncedFunction(this.handleKeyup.bind(this), 300);
        this.inputElement.addEventListener('keyup', debouncedHandler);
        this.inputElement.addEventListener('change', debouncedHandler);
        this.inputElement.addEventListener('search', debouncedHandler);
        this.inputElement.addEventListener('input', debouncedHandler);
    }

    handleKeyup(event) {
        const query = this.getValue();
        const componentEvent = new ComponentEvent(SelecterFilterConfig.changedQueryEventName, {target: this});
        console.log("[SelectorFilter] handleKeyup() componentEvent: ", componentEvent);
        this.selecter.fireEvent(componentEvent, { query: query });
    }

    getValue() {
        return this.inputElement.value;
    }

    render() {
    }

}

